import React from "react";
import { Button, Divider, Modal } from "antd";
import {
  FeatureGroup,
  MapContainer,
  TileLayer,
  GeoJSON,
  Polygon,
  Marker,
} from "react-leaflet";
import { useSelector } from "react-redux";
import { selectLicenseList } from "../../api/redux";
import SpanData from "./SpanData";
import CurrencyFormat from "react-currency-format";

export default (props) => {
  const [coordinates, setCoordinates] = React.useState(null);
  const { show, onClose } = props;

  const data = useSelector(selectLicenseList).currentDetail;

  return (
    <>
      {data && (
        <Modal
          title={`فرصت سرمایه گداری: ${data?.title}`}
          className="as-modal d-flex-column text-right p-5"
          footer={false}
          width={"75%"}
          visible={show}
          onCancel={onClose}
        >
          <div className="d-flex flex-wrap">
            <h6 className="col-md-4 col-12 my-1">
              <span style={{ color: "#6c6c6c", fontSize: "15px" }}>عنوان</span>{" "}
              <br />
              <h5 className="mt-1 lh-30">{data?.title}</h5>
            </h6>

            {data.amount && (
              <h6 className="col-md-4 col-12 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  مبلغ سرمایه گذاری
                </span>{" "}
                <br />
                <h5 className="mt-1 lh-30">
                  <CurrencyFormat
                    value={data.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="mx-1">میلیارد ریال</span>
                </h5>
              </h6>
            )}
          </div>
          <Divider className="col-12 my-2" />
          <div className="d-flex flex-wrap">
            {data.Township && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  شهرستان
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.Township?.title}</h5>
              </div>
            )}
            {data.Part && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>بخش</span>{" "}
                <br />
                <h5 className="mt-1 lh-30">{data.Part?.title}</h5>
              </div>
            )}
            {data.City && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>شهر</span>
                <br />
                <h5 className="mt-1 lh-30">{data.City?.title}</h5>
              </div>
            )}
            {data.RuralArea && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  دهستان
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.RuralArea?.title}</h5>
              </div>
            )}
            {data.Village && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  روستا
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.Village?.title}</h5>
              </div>
            )}
          </div>
          <Divider className="col-12 my-2" />
          <div className="d-flex flex-wrap">
            {data.Sector && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  بخش سرمایه گذاری
                </span>{" "}
                <br />
                <h5 className="mt-1 lh-30"> {data.Sector?.title}</h5>
              </div>
            )}
            {data.SubSector && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  زیر بخش سرمایه گذاری
                </span>{" "}
                <br />
                <h5 className="mt-1 lh-30">{data.SubSector?.title}</h5>
              </div>
            )}
            <Divider className="col-12 my-2" />
            {data.OpportunityType && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  نوع فرصت
                </span>{" "}
                <br />
                <h5 className="mt-1 lh-30">{data.OpportunityType?.title}</h5>
              </div>
            )}
            {data.ParticipationType && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  روش مشارکت
                </span>{" "}
                <br />
                
                <h5 className="mt-1 lh-30">{data.ParticipationType.title}</h5>
              </div>
            )}
            {data.OperationPlace && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  محل اجرا
                </span>{" "}
                <br />
                <h5 className="mt-1 lh-30">{data.OperationPlace.title}</h5>
              </div>
            )}
            <Divider className="col-12 my-2" />
            {data.ActivityGroup && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  گروه فعالیت
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.ActivityGroup?.title}</h5>
              </div>
            )}
            {data.Product && (
              <div className="col-12 col-md-6 col-lg-4 my-1">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  محصول
                </span>
                <br />
                <h5 className="mt-1 lh-30"> {data.Product?.title}</h5>
              </div>
            )}
          </div>
          <div className="d-flex flex-wrap">
            {" "}
            {data.Organization && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  سارمان
                </span>
                <br />
                <h5>{data.Organization?.title}</h5>
              </div>
            )}{" "}
            {data.Unit && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>واحد</span>
                <br />
                <h5 className="mt-1 lh-30">{data.Unit?.title}</h5>
              </div>
            )}
            {data.category && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>رده</span>
                <br />
                <h5 className="mt-1 lh-30">{data.category}</h5>
              </div>
            )}
            {data.OpportunityType && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  روش سرمایه گذاری
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.OpportunityType?.title}</h5>
              </div>
            )}{" "} */}
            {/* {data.ParticipationType && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  روش مشارکت
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.ParticipationType?.title}</h5>
              </div>
            )} */}
            <Divider className="col-12 my-2" />
            {data.yearlyCap && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  ظرفیت سالانه
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.yearlyCap}</h5>
              </div>
            )}{" "}
            {data.recycleDuration && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  دوره بازگشت سرمایه
                </span>
                <br />
                <h5 className="mt-1 lh-30">{data.recycleDuration} ماه</h5>
              </div>
            )}{" "}
            {data.irr && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  نرخ بازدهی داخلی (IRR)
                </span>
                <br />
                <h5 className="mt-1 lh-30">
                  <CurrencyFormat
                    value={data.irr}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="mx-1">درصد</span>
                </h5>
              </div>
            )}{" "}
            {data.npv && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  ارزش خالص فعلی (NPV)
                </span>
                <br />
                <h5 className="mt-1 lh-30">
                  <CurrencyFormat
                    value={data.npv}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="mx-1">میلیارد ریال</span>
                </h5>
              </div>
            )}
            {data.employment && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
                  اشتغالزایی
                </span>
                <br />
                <h5 className="mt-1 lh-30">
                  <CurrencyFormat
                    value={data.employment}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="mx-1">نفر</span>
                </h5>
              </div>
            )}
            {data.fileLink && (
              <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
                <a className="mt-1 lh-30" href={data.fileLink}>
                  <span className="mx-1">توضیحات بیشتر</span>
                </a>
              </div>
            )}
            <Divider className="col-12 my-2" />
            <div className="col-12" style={{ height: "13rem" }}>
              {" "}
              <MapContainer zoom={13} center={data?.point?.coordinates}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  key={1}
                />
                <FeatureGroup>
                  {data.spanData ? (
                    <SpanData data={data} />
                  ) : (
                    <Marker position={data?.point?.coordinates} />
                  )}
                </FeatureGroup>
              </MapContainer>
            </div>
            <div className="col-12 my-3 d-flex justify-content-end">
              <Button
                className="w-100"
                style={{
                  height: "3rem",
                  borderRadius: "6px",
                }}
              >
                <a href={data.link} target="_blank">
                  اعلام أمادگی
                </a>
              </Button>
            </div>
            {/* <div className="col-6 my-3 d-flex justify-content-end">
              <Button
                className="w-100"
                style={{
                  height: "3rem",
                  borderRadius: "6px",
                }}
              >
                <a href={data.fileLink} target="_blank">
                  فایل جزییات
                </a>
              </Button>
            </div> */}
          </div>
        </Modal>
      )}
    </>
  );
};
